import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Network } from '../domain/network.model';
import { Publisher, PublisherCreateRequest } from '../domain/publisher.model';
import { HttpUtils } from '../utils/http-utils';
import { Page } from '../domain/page.model';
import { MixpanelService } from './mixpanel.service';
import { MixpanelEvents } from '../analytics/mixpanel-events';
import { withMixpanelOutcome } from '../analytics/mixpanel-tracking.utils';


@Injectable({
  providedIn: 'root',
})
export class NetworkService {

  constructor(
    private httpClient: HttpClient,
    private mixpanel: MixpanelService
  ) {
  }

  listNetworksPaging(filter?: any): Observable<Page<Network>> {
    return this.httpClient.get<Page<Network>>(`${environment.serviceUrl}/api/networks`, {
      params: HttpUtils.getHttpParams(filter)
    });
  }

  listNetworks(): Observable<Network[]> {
    return this.httpClient.get<Network[]>(`${environment.serviceUrl}/api/networks/list`);
  }

  create(request: any) {
    return this.httpClient.post(`${environment.serviceUrl}/api/networks`, request);
  }

  activateNetwork(id: string) {
    return this.httpClient.put(`${environment.serviceUrl}/api/networks/${id}/activate`,{});
  }

  archiveNetwork(id: string) {
    const res = this.httpClient.put(`${environment.serviceUrl}/api/networks/${id}/archive`, {});
    return res;
  }

  update(networkId: string, request: any) {
    return this.httpClient.put(`${environment.serviceUrl}/api/networks/${networkId}`, request);
  }

  getNetworkById(id) {
    return this.httpClient.get<Network>(`${environment.serviceUrl}/api/networks/${id}`);
  }

  createPublisher(publisher: PublisherCreateRequest, id: string): Observable<Publisher> {
    return this.httpClient
      .post<Publisher>(
        `${environment.serviceUrl}/api/networks/${id}/publisher`,
        publisher
      )
      .pipe(
        withMixpanelOutcome(this.mixpanel, {
          successEvent: MixpanelEvents.PublisherCreated,
          failureEvent: MixpanelEvents.PublisherCreateFailed,
          successProps: (created) => ({
            publisher_id: created?.id,
            publisher_name: created?.name,
            network_id: id,
            origin: 'network',
          }),
          failureProps: () => ({
            publisher_name: publisher?.name,
            network_id: id,
            origin: 'network',
          }),
        })
      );
  }

  getStatusCount(filter: any) {
    return this.httpClient.get(`${environment.serviceUrl}/api/networks/count-by-status`, {
      params: HttpUtils.getHttpParams(filter)
    });
  }
}

